// extracted by mini-css-extract-plugin
export default {"center":"ErrorBoundary_center__DQBN8"};